import {DataModificationsHeader} from 'audit/DataModifications';
import {FromServerDocument, ToServerDocumentWithMetadata} from 'notebook/documents/DocumentConstants';
import {FromServerId, VersionSummary} from 'notebook/ELNConstants';
import {CidIdMap, CidNotePartProvenanceIdMap} from 'notebook/notes/NoteConstants';
import {ServerDocumentEditorLock} from 'notebook/realtime/DocumentEditorLockConstants';
import * as net from 'util/Net';

export interface DocumentsByVersion {
  data: Array<VersionSummary<FromServerId>>;
  parent?: {
    id: string;
    versionId: string;
    name: string;
    modifiedAt: string;
  };
}

export interface DocumentsList {
  documents: Array<FromServerDocument>;
}

const DocumentDAO = {
  get: (id: string): JQueryPromise<FromServerDocument> => net.getJSON(`/1/api/documents/${id}`, {view: true}),

  getAll: (ids: Array<string>): Promise<DocumentsList> =>
    net.getJSONPromise(`/1/api/documents/`, {ids: ids.join(',')}),

  getVersions: (id: string): JQueryPromise<DocumentsByVersion> =>
    net.getJSON(`/1/api/documents/${id}/versions/`),

  update: (
    id: string,
    data: ToServerDocumentWithMetadata,
    dataModsHeaders?: DataModificationsHeader
  ): JQueryPromise<{
    cidIdMap: CidIdMap;
    cidNotePartProvenanceIdMap?: CidNotePartProvenanceIdMap;
    lock?: ServerDocumentEditorLock;
  }> => net.patchJSON({url: `/1/api/documents/${id}`, data, extraHeaders: dataModsHeaders}),

  getVersion: (id: string, versionId: string | number): JQueryPromise<FromServerDocument> =>
    net.getJSON(`/1/api/documents/${id}/versions/${versionId}`),

  bulkUpdate: (
    documents: Array<
      ToServerDocumentWithMetadata & {
        id: string;
      }
    >,
    dataModsHeader?: DataModificationsHeader
  ): JQueryPromise<{
    responses: Array<{
      id: string;
      cidIdMap: CidIdMap;
      cidNotePartProvenanceIdMap?: CidNotePartProvenanceIdMap;
      lock?: ServerDocumentEditorLock;
    }>;
  }> => net.patchJSON({url: `/1/api/documents:bulk_patch`, data: {documents}, extraHeaders: dataModsHeader}),
};

export default DocumentDAO;
